import React, { useCallback } from 'react';

import { Formik } from 'formik';
import type { FormikProps } from 'formik';
import type { IRefundFilter } from 'v2/interfaces/reports/refunds';
import { refundsService, initialFilter } from 'v2/services/reports/refunds';

import { Form } from './Form';

export const Filter = () => {
  const onSubmit = useCallback((values: IRefundFilter, { setSubmitting }: FormikProps<IRefundFilter>) => {
    refundsService.setFilter(values);
    setSubmitting(false);
  }, []);

  return (
    <Formik initialValues={initialFilter} onSubmit={onSubmit}>
      <Form />
    </Formik>
  );
};
